import { Button, styled, IconButton } from "@mui/material";
import React from "react";

const StyledButton = styled(({ children, isIconButton, ...props }) =>
  isIconButton ? (
    <IconButton variant="outlined" {...props}>
      {children}
    </IconButton>
  ) : (
    <Button variant="outlined" {...props}>
      {children}
    </Button>
  )
)(({ theme }) => ({
  boxSizing: "border-box",
  minHeight: "36px",
  // minWidth: "83px",
  border: "1px solid #dbdee6",
  borderRadius: "4px",
  background: "var(--secondary)",
  color: "#fff",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "16px",
  textAlign: "center",
  textTransform: "none",
  ":hover": {
    border: "1px solid #dbdee6",
    background: "var(--secondary)",
  },
}));

const SecondaryButton = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};
export default SecondaryButton;
